import AnomalyMatrix from './AnomalyMatrix';
export default AnomalyMatrix;
